import { css } from '@emotion/react';

export default $ => css`
  nav.navbar {
    /* Flex layout was previously provided by Bootstrap's emotion CSS.
       Now that Bootstrap CSS-in-JS is removed, we own these here so they
       land in non-layered CSS (higher priority than @layer components). */
    display: flex !important;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    background-color: ${$.white};
    color: ${$.primaryMain};
    height: ${$.navbarHeight};
    border-bottom: 1px solid ${$.gray100};
    box-shadow: inset 0px -2px 5px rgba(0, 0, 0, 0.1);

    .navbar-breadcrumb-link {
      &:hover {
        color: ${$.primaryMain} !important;
        text-decoration: underline !important;
      }
    }

    .nav-icon {
      font-size: 1.15rem;
      color: ${$.primaryMain};
    }

    .topbar-clock {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      color: ${$.gray500};
    }

    .topbar-clock-time {
      font-size: 0.85rem;

      .ampm {
        opacity: 0.7;
      }
    }

    .nav.navbar-nav {
      > .navbar-text {
        display: flex;
        align-items: center;
        padding-left: 5px;
        padding-right: 5px;
      }

      > .nav-item {
        display: flex;
        align-items: center;
      }
    }

    a.nav-link {
      color: ${$.gray500};
    }

    .navbar-help-text {
      color: ${$.primaryMain};
    }

    .navbar-text.text-title {
      color: ${$.primaryMain};
      font-weight: bold;
    }
  }

  .medium-panel {
    width: 350px;
    max-height: 550px;
    overflow-y: auto;
  }

  .tooltip > div.tooltip-inner {
    margin-left: -9px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .bs-tooltip-auto[x-placement^='right'] span.arrow::before,
  .bs-tooltip-right .arrow::before {
    border-right-color: ${$.white};
    opacity: 0%;
  }

  .nav-notification-mobile {
    display: none;
  }
`;
